"use client";

import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/** Bouton retour en haut - apparaît après un vrai défilement, discret. */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Retour en haut de page"
      title="Retour en haut"
      className="fixed right-5 bottom-5 z-40 grid h-11 w-11 place-items-center rounded-full border border-corail/15 bg-basalte/70 text-corail shadow-lg shadow-black/40 backdrop-blur-md transition-colors hover:border-or hover:text-or"
    >
      <ArrowUp className="h-[18px] w-[18px]" aria-hidden />
    </button>
  );
}
